import { type ReactNode, createContext, useContext, useState } from 'react';

interface LandingContextType {
  isRegistrationPopupOpen: boolean;
  openRegistrationPopup: () => void;
  closeRegistrationPopup: () => void;
}

const LandingContext = createContext<LandingContextType>({
  isRegistrationPopupOpen: false,
  openRegistrationPopup: () => null,
  closeRegistrationPopup: () => null,
});

interface Props {
  children: ReactNode;
}

export function LandingProvider({ children }: Props) {
  const [isRegistrationPopupOpen, setIsRegistrationPopupOpen] = useState(false);

  const openRegistrationPopup = () => {
    setIsRegistrationPopupOpen(true);
  };

  const closeRegistrationPopup = () => {
    setIsRegistrationPopupOpen(false);
  };

  return (
    <LandingContext.Provider
      value={{
        isRegistrationPopupOpen,
        openRegistrationPopup,
        closeRegistrationPopup,
      }}
    >
      {children}
    </LandingContext.Provider>
  );
}

export function useLanding() {
  const context = useContext(LandingContext);
  if (context === undefined) {
    throw new Error('useLanding must be used within a LandingContext');
  }
  return context;
}
